
export class Controller {

    /** @ngInject */
    constructor($state,Alert, SharedAccountsService) {
        this.Alert = Alert;
        this.$state=$state;
        this.SharedAccountsService = SharedAccountsService;
    }

    $onInit() {
        if(this.copyAccount != null) {
            this.account = this.copyAccount;
            this.searchItem = this.account.publicService.serviceName !== 'Other' ? this.account.publicService.serviceName : 'Custom';
        } else {
            this.account = {
                showOtpEnabled: true,
                showPasswordEnabled: true,
                showNoteEnabled: false,
            };
        }

        this.publicServicesWithSso$.get().then(items => this.publicServices=items);
    }

    save() {
        this.isSaving = true;
        this.SharedAccountsService.createCompanyServiceAccounts(
            {
                companyId: this.companyId,
                publicServiceId: this.account.publicService.id,
            },
            {
                username: this.account.username,
                password: this.account.password,
                serviceLoginUrl: this.account.serviceLoginUrl,
                enabled2fa: false,
                showOtpEnabled: false,
                showPasswordEnabled: this.account.showPasswordEnabled,
                showNoteEnabled: this.account.showNoteEnabled,
                note: this.account.note,
                customServiceName: this.account.customServiceName
            }
        )
            .$promise
            .then(account => {
                this.$state.go('company.sharing-center.shared-passwords');
                this.Alert('success', 'company.sharing-center.add.added');
            })
            .finally(() => this.isSaving = false)
    }

    saveDisabled(form) {
        return this.isSaving || form.$invalid || !this.account.publicService;
    }

    selectCustom() {
        this.searchItem = 'Custom';
        this.account.publicService = this.publicServices.find(i => i.slug === "other");
    }

    serviceSelected(service) {
        this.account.publicService = service;
        if (service.slug !== "other") {
            this.account.customServiceName = null;
        }
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-passwords/add/add-shared-password.controller.js